export default "__VITE_ASSET__DcyS1xhK__"